import { REGEXP_URL } from '@/config';

// http或https的URL
export function isUrl(path: string): boolean {
  return REGEXP_URL.test(path);
}

// 有效的URL
export function isValidUrl(url: string) {
  try {
    // eslint-disable-next-line no-new
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
}

// 图片验证
export function imageFormat(file: any, wh: any = [], size = 300) {
  const isIMG =
    file.file.file.type === 'image/jpg' || file.file.file.type === 'image/jpeg' || file.file.file.type === 'image/png';
  const isLt = file.file.file.size / 1024 <= size;
  if (!isIMG) {
    window.$message?.error('上传图片只支持jpg、jpeg、png格式!');
  }
  if (!isLt) {
    window.$message?.error(`上传图片大小不能超过${size}KB!`);
  }
  if (wh.length > 0 && wh.length > 1) {
    const isSize = new Promise<void>((resolve, reject) => {
      const width = wh[0]; // 限制图片尺寸为654X270
      const height = wh[1];
      const _URL = window.URL || window.webkitURL;
      const img = new Image();
      img.onload = function () {
        const valid = img.width === width && img.height === height;
        if (valid) {
          resolve();
        } else {
          reject();
        }
      };
      img.src = _URL.createObjectURL(file.file.file);
    }).then(
      () => {
        return file;
      },
      () => {
        window.$message?.error(`上传图片尺寸率建议${wh[0]}*${wh[1]}`);
        return Promise.reject();
      }
    );
    return isIMG && isLt && isSize;
  }
  return isIMG && isLt;
}
